import { useEffect } from "react";
import { applyProDocumentChrome, resetDocumentChrome } from "@/lib/pro-document-chrome";
import type { ProTheme } from "@/stores/pro-theme";

/**
 * Keeps html/body and `theme-color` aligned with pro dashboard surfaces so mobile
 * browser chrome (status bar, overscroll) is not the consumer paper color.
 * On mobile, `#root` stays transparent so Safari 26+ samples the dashboard shell's
 * `bg-pro-bg` (fixed from viewport top; updates with pro-light/pro-dark).
 */
export function useSyncProDocumentChrome(theme: ProTheme, isMobileCanvas: boolean): void {
  useEffect(() => {
    applyProDocumentChrome(theme, isMobileCanvas);
  }, [theme, isMobileCanvas]);

  useEffect(() => () => resetDocumentChrome(), []);
}
